export default {
  paymentSummary: {
    inProgress: {
      title: "Payment in progress",
      message:
        "We are processing your payment now. Please do not close your browser.",
    },
    confirmation: {
      modal: {
        title: "Confirm payment",
      },
    },
    errors: {
      COUPON_INVALID:
        "Sorry, the promo code you've entered is invalid/fully redeemed.",
      COUPON_EXPIRED:
        "Sorry, the promo code you've entered is invalid/fully redeemed.",
      COUPON_NOT_ELIGIBLE:
        "Sorry, the promo code you've entered is invalid/fully redeemed.",
      COUPON_FULLY_REDEEMED:
        "Sorry, the promo code you've entered is invalid/fully redeemed.",
      COUPON_MINIMUM_MISMATCH:
        "Sorry, you have not met the minimum amount to use this promo code.",
      COUPON_PRODUCT_MISMATCH:
        "Sorry, the promo code you've entered is invalid/fully redeemed.",
      CART_INVALID: "Sorry, there seems to be an unexpected error.",
      CART_ATTRIBUTE_MISMATCH: "Sorry, there seems to be an unexpected error.",
      PRODUCT_INVALID: "Sorry, there seems to be an unexpected error.",
      PRODUCT_NOT_ELIGIBLE: "Sorry, there seems to be an unexpected error.",
      PRODUCT_PRICE_MISMATCH: "Sorry, there seems to be an unexpected error.",
      PRODUCT_EXPIRED:
        "Sorry, the product you've selected is expired/fully redeemed.",
      PRODUCT_FULLY_REDEEMED:
        "Sorry, the product you've selected is expired/fully redeemed.",
      default: "Sorry, there seems to be an unexpected error.",
    },
    errorHeader: {
      CART_INVALID: "Oops, something went wrong!",
      CART_ATTRIBUTE_MISMATCH: "Oops, something went wrong!",
      PRODUCT_INVALID: "Oops, something went wrong!",
      PRODUCT_NOT_ELIGIBLE: "Oops, something went wrong!",
      PRODUCT_PRICE_MISMATCH: "Oops, something went wrong!",
      PRODUCT_EXPIRED: "Oops, check-out error!",
      PRODUCT_FULLY_REDEEMED: "Oops, check-out error!",
      default: "Oops, something went wrong!",
    },
  },
};
